export const routes = {
    HOME: { path: '/' },
    ABOUT: { path: '/about' },
    MODULES: { path: '/' },
    MODULE: { path: '/module/:moduleId' },
    UNIT: { path: '/module/:moduleId/unit/:unitId' },
    FAVORITES: { path: '/favorites' },
    LOGIN: { path: '/login' },
    FORGOT_PASSWORD: { path: '/login/forgot-password' },
    PASSWORD_RECOVERY: { path: '/login/recovery' },
    PASSWORD_RESET: { path: '/activate' },
    RESOURCES_INT: { path: '/resources/international' },
    RESOURCES_NAT: { path: '/resources/national' },
    RESOURCES_CONTENT: { path: '/resources/:country/content' },
    MY_ACCOUNT: { path: '/account' },
    LEGAL: { path: '/privacy' },
    CONTACTS: { path: '/contacts' },
    FAQS: { path: '/faqs' },
    PAGE_404: { path: '/404' },
    STYLEGUIDE: { path: '/styleguide' },
    TRANSLATIONS: { path: '/translations' }
};
